import { forwardRef, type Ref, type SVGProps } from "react";
const IconUnconstrainedWalkThroughOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M29 14.178c0-1.283-.555-2.51-1.536-3.394l-9.88-8.709a2.47 2.47 0 0 0-3.168 0l-9.88 8.709C3.555 11.669 3 12.895 3 14.178v14.09C3 29.5 4.058 30.5 5.364 30.5h21.272c1.306 0 2.364-1 2.364-2.233zM5.868 12.275c-.57.519-.868 1.209-.868 1.902v14.09c0 .026.008.07.066.125a.43.43 0 0 0 .298.108h21.272a.43.43 0 0 0 .298-.108c.058-.055.066-.099.066-.125v-14.09c0-.692-.297-1.383-.869-1.902L16.28 3.591A.44.44 0 0 0 16 3.5a.44.44 0 0 0-.279.091z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.388 13.4a1 1 0 1 0-1.16-1.63l-3.069 2.186a2 2 0 0 0 0 3.258l3.07 2.185a1 1 0 0 0 1.16-1.629l-1.63-1.16c1.457.184 2.709.589 3.634 1.103C22.74 18.46 23 19.175 23 19.5s-.26 1.039-1.607 1.787c-1.28.71-3.182 1.213-5.393 1.213s-4.113-.502-5.393-1.213C9.26 20.54 9 19.825 9 19.5s.26-1.039 1.607-1.787q.398-.221.871-.412l-.002-.006a1 1 0 0 0-.543-1.924v-.004l-.032.012a1 1 0 0 0-.168.066C8.47 16.354 7 17.831 7 19.5c0 2.761 4.03 5 9 5s9-2.239 9-5c0-2.436-3.134-4.464-7.285-4.91z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconUnconstrainedWalkThroughOutlineSVG);
ForwardRef.displayName = "IconUnconstrainedWalkThroughOutline";
export { ForwardRef as IconUnconstrainedWalkThroughOutline };
